<!--  更贴   -->
<template>
  <div class="container">
    <div class="top_head">
      <div class="back" @click="back">
        <img src="@/assets/blackback2@2x.png" alt="">
      </div>
      <div :class="show==true && isContent?'sub_btn':'no_sub_btn'" @click="submit">提交</div>
    </div>
    <div class="inp_box">
      <!-- <van-field
        v-model="message"
        rows="10"
        autosize
        type="textarea"
        placeholder="写跟贴"
        show-word-limit
      /> -->
      <div
        id="edit_box"
        ref="edit"
        contentEditable="true"
        class="edit_box"
        @click.stop="hideemoji"
      >
        <div tabindex="0" class="test" v-html="message_html"></div>
      </div>
    </div>
    <div class="foot_box" :class="is_emoji ? 'hasemoji' : 'noemoji'">
      <div class="tab_box">
        <van-uploader :after-read="afterRead" :preview-image="false">
          <img src="@/assets/xc.png" alt="">
        </van-uploader>
      </div>
      <div class="tab_box">
        <van-uploader
          capture="camera"
          :after-read="afterRead"
          :preview-image="false"
        >
          <img src="@/assets/xj.png" alt="">
        </van-uploader>
      </div>
      <div class="tab_box" @click="showemoji">
        <img src="@/assets/biaoqing.png" alt="">
      </div>
      <div v-show="is_emoji" class="fot_menu">
        <div class="emoji_box">
          <div class="emoji_div">
            <!-- <div v-for="(item,index) in emojiArr" :key="index" class="emoji_text">
                  <img :src="item.key" alt="">
                </div> -->
            <emotion
              v-show="emotionShow"
              ref="emotion"
              class="emotion"
              :height="90"
              @emotion="handleEmotion"
            ></emotion>
          </div>
          <!-- <div class="emoji_send">
            <span class="emoji_btn" @click="send_emoji">发送</span>
              <span class="del_emoji" @click="del_emoji">
              <img src="@/assets/emotion_del.png" alt="">
            </span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Toast } from 'vant'
import { insertReply } from '@/api/bbsdetail.js'
import Emotion from '@/components/emotion/index'
import tool from '@/utils/tools.js'

// 键盘收起
document.addEventListener('focusout', () => {
  setTimeout(() => {
    const height = document.documentElement.scrollTop || document.body.scrollTop
    window.scrollTo(0, height + 1)
    window.scrollTo(0, height - 1)
  }, 20)
})
export default {
  components: {
    Emotion
  },
  data() {
    return {
      message: '',
      // tid: '42364605',
      tid: this.$route.query.tid,
      is_emoji: false,
      emotionShow: true,
      img: '',
      imgArr: [],
      upArr: [],
      fd: '',
      message_html: '',
      show: true,
      isContent: false
    }
  },
  computed: {},
  created() {
    // 自动聚焦
    setTimeout(() => {
      const sss = document.getElementById('edit_box')
      if (sss) {
        sss.focus()
      }
    }, 200)
  },
  mounted() {
    document.getElementById('edit_box').addEventListener('DOMSubtreeModified', () => {
      // 监听内容
      this.realTime()
    }, false)
  },
  methods: {
    realTime() {
      if (this.$refs.edit.innerHTML) {
        this.isContent = true
      } else {
        this.isContent = false
      }
    },
    submit() {
      // this.message_html = this.$refs.edit.innerHTML
      this.show = false
      var info = {
        // agency_id: 20000,
        tid: this.tid,
        message: this.$refs.edit.innerHTML,
        type: 1
      }
      // console.log(this.message_html)
      insertReply(info).then((res) => {
        if (res.errNo === 0) {
          Toast.success('发布成功')
          this.goBack()
        } else {
          Toast.fail(res.msg)
          this.show = true
        }
      })
    },
    goBack() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp'
            , '返回'
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.go(-1)
      }
    },
    showemoji() {
      this.is_emoji = true
      document.activeElement.blur()
    },
    // 上传文件
    afterRead(e) {
      this.imgArr = []
      this.fd = new FormData()
      this.fd.append('files', e.file)
      this.upArr = this.fd.getAll('files')
      axios
        .post('https://f.zhulong.com/uploadZhulongImgForReal.php', this.fd)
        .then((res) => {
          console.log(res)
          this.img = res.data.url
          console.log(this.img)
          this.$refs.edit.innerHTML += `
          <img src="${this.img}" style="max-width:80%" alt="">
          `
        })
    },
    handleEmotion(i) {
      this.$refs.edit.innerHTML += `
       <span> ${i}</span>
      `
    },
    send_emoji() {
      this.submit()
    },
    // del_emoji() {
    //   var text = this.message.split('{')
    //   var index = text.length - 1
    //   if (index > 0) {
    //     text.splice(index, 1)
    //     this.message = text.join('{')
    //   }
    // },
    back() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp'
            , '返回'
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.go(-1)
      }
    },
    hideemoji() {
      this.is_emoji = false
    }
    // 将匹配结果替换表情图片
    // emotion(res) {
    //   const word = res.replace(/\#|\;/gi, '')
    //   const list = [
    //     '惊讶', '流泪', '害羞', '闭嘴', '睡觉', '发怒', '酷', '抓狂', '吐', '偷笑',
    //     '疑问', '嘘', '晕', '衰', '拜拜', '猪', '爱心', '心碎', '抱抱', '强', '左哼哼', '右哼哼',
    //     '打哈欠', '鄙视', '委屈', '阴险', '亲亲', '可怜', '来', '不', '困', '流汗',
    //     '咒骂', '弱', '好的', '挖鼻子', '鼓掌', '爱你', '大哭', '蛋糕', '给力', '滚',
    //     '蜡烛', '礼物', '胜利'
    //   ]
    //   const index = list.indexOf(word)
    //   return `<img src="https://edu.zhulong.com/img/emoji/${index}.png" align="middle">`
    // },
    // triggerCloseEmotion() {
    //   const _this = this
    //   document.addEventListener('click', function(e) {
    //     if (e.target === _this.$refs.emojiBtn) {
    //       return
    //     }
    //   })
    // }
  }
}
</script>

<style lang='less' scoped>
* {
  box-sizing: border-box;
}
.top_head {
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  height: 100px;
  width: 100%;
  border-bottom: 1px solid #e4e4e4;
  .back {
    line-height: 100px;
    float: left;
    img {
      width: 50px;
      vertical-align: middle;
      margin-left: 30px;
    }
  }
  .sub_btn {
    float: right;
    width: 124px;
    height: 54px;
    line-height: 54px;
    text-align: center;
    margin-top: 25px;
    margin-right: 20px;
    color: #fff;
    background-color: #ee2e2e;
    border-radius: 10px;
  }
  .no_sub_btn{
    float: right;
    width: 124px;
    height: 54px;
    line-height: 54px;
    text-align: center;
    margin-top: 25px;
    margin-right: 20px;
    color: #fff;
    background-color: #ccc;
    border-radius: 10px;
  }
}
.inp_box {
  padding: 120px 4%;
  .msg_box {
    outline: none;
    width: 100%;
  }
  .edit_box {
    // min-height: 100px;
    height: 75vh;
  }
}
.foot_box {
  height: 100px;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #f9f9f9;
  .tab_box {
    float: left;
    line-height: 100px;
    img {
      vertical-align: middle;
      width: 50px;
      margin: 0 50px;
    }
  }
}
/* 筑龙表情 */
.hasemoji {
  bottom: 340px;
}
.fot_menu {
  border-top: 2px solid #dddddd;
  height: 340px;
  width: 100%;
  overflow: hidden;
  background: #f9f9f8;
}
.emoji_box {
  height: 340px;
  width: 100%;
  position: relative;
}
.emoji_send {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 0 4%;
  height: 100px;
}
.emoji_btn {
  float: right;
  width: 15%;
  background: #ee2d2e;
  color: #fff;
  height: 60px;
  line-height: 60px;
  border-radius: 10px;
  text-align: center;
  margin-top: 20px;
}
.del_emoji {
  float: right;
  width: 15%;
  margin-top: 24px;
  height: 60px;
  line-height: 60px;
  margin-right: 4%;
}
.del_emoji img {
  height: 52px;
}
.emoji_div {
  height: 340px;
  width: 100%;
  padding: 0 4%;
  overflow: hidden;
}
.emoji_text {
  float: left;
  width: 60px;
  margin: 18px;
  height: 60px;
}
</style>
